// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1m6cs","title":"Info_title__1NnaG","selects":"Info_selects__Ei0GU","requiredAsterisk":"Info_requiredAsterisk__1mZeK"};